var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VastMimeTypeSelect',{attrs:{"value":_vm.value,"mime-types":_vm.mimeTypes,"loading":_vm.loading,"error-message":_vm.errorMessage},on:{"input":_vm.onValueChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }